import { Box, Container, Stack, Typography } from "@mui/material";
import CheckIcon from "@mui/icons-material/CheckCircle";

export default function GolfTrakAuth() {
  return (
    <Container sx={{ p: 3, textAlign: 'center' }} maxWidth="md">
      <Stack spacing={2}>
        <Box>
          <CheckIcon sx={{ fontSize: 48 }} />
        </Box>
        <Typography variant="h5">Account Linked</Typography>
        <Typography>Your GolfTrak account has been linked. You should be able to return to the OpenGolfSim app now.</Typography>
      </Stack>
    </Container>
  );
}